@if (reviews$ | async; as reviews) {
  <div class="d-flex justify-content-start align-items-end">
    @if (
      (reviews.meta.record_count !== 0 && reviews.meta.product.star_rating > 2) ||
      reviews.meta.product.star_rating === 0
    ) {
      <dcp-star-rating [starRating]="reviews.meta.product.star_rating" class="d-inline-block"></dcp-star-rating>
      <span class="align-baseline small-line-height ms-3 udex-cursor-pointer">
        @if (reviews.meta.record_count !== 0 && reviews.meta.product.star_rating > 2) {
          <span
            (click)="scrollToReviewSection()"
            (keyup.enter)="scrollToReviewSection()"
            class="focusable focusable__element underline--hover--black"
            id="hero-review-scroll-to-review-section"
            tabindex="0">
            {{ 'productReview.reviewCount' | cxTranslate: {count: reviews.meta.record_count} }}
          </span>
        }
        @if (reviews.meta.record_count === 0) {
          <span id="hero-review-open-write-review-modal">
            <span class="text-blue-gray me-1">
              {{ 'productReview.reviewCountEmpty' | cxTranslate: {count: reviews.meta.record_count} }}
            </span>
            <span
              (click)="reviewDialogService.openWriteAReviewDialog(reviews.meta.product)"
              (keyup.enter)="reviewDialogService.openWriteAReviewDialog(reviews.meta.product)"
              class="focusable focusable__element underline--hover--black"
              tabindex="0">
              {{ 'productReview.writeAReview' | cxTranslate }}
            </span>
          </span>
        }
      </span>
    }
  </div>
}
